import { formatDateToApi } from "@/common/helpers/format-date";
import { useMemo, useState } from "react";

/**
 * Aging buckets and overdue metrics are computed server-side relative to `referenceDate`.
 * Defaults it to the browser's local calendar date so results match what the user sees.
 */
export function useOpenPositionSearchBody<TBody extends { referenceDate?: string }>(body?: TBody): TBody {
  const [today] = useState(() => formatDateToApi(new Date()));

  return useMemo(() => ({ ...body, referenceDate: body?.referenceDate ?? today }) as TBody, [body, today]);
}
